import React from 'react'
import { useTranslation } from 'react-i18next'

import {
    StyledPartnersAboutSection,
    StyledPartnersAboutDescription,
    StyledAboutColumns,
    AboutCard,
    ImageWrapper,
    StyledAboutTextWrapper,
    StyledAboutHeading,
    StyledAboutParagraph,
    StyledPartnersAboutTextWrapper,
} from './aboutSection.style'

const AboutSection = ({ source = '' }) => {
    const { t } = useTranslation()
    return (
        <StyledPartnersAboutSection>
            <StyledPartnersAboutDescription>
                <h3>
                    {/* {source
                        ? 'Trade-In  Your Phone In 3 Steps'
                        : t('sell your phone')} */}
                    {t('description.sell_header')}
                </h3>
            </StyledPartnersAboutDescription>
            <StyledAboutColumns>
                <AboutCard>
                    <ImageWrapper
                        src={'/assets/images/icons/webIcons_priceIcon.svg'}
                        alt="check price"
                    />
                    {source ? (
                        <StyledPartnersAboutTextWrapper>
                            <StyledAboutHeading>
                                {t('description.buy_back_step1')}
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                View our fixed prices based on your device model
                            </StyledAboutParagraph>
                        </StyledPartnersAboutTextWrapper>
                    ) : (
                        <StyledAboutTextWrapper>
                            <StyledAboutHeading>
                                {t('description.buy_back_step1')}
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                {t('description.buy_back_detail1')}
                            </StyledAboutParagraph>
                        </StyledAboutTextWrapper>
                    )}
                </AboutCard>
                <AboutCard>
                    {source ? (
                        <ImageWrapper
                            src={
                                '/assets/images/icons/webIcons_selectStore.svg'
                            }
                            alt="store icon"
                        />
                    ) : (
                        <ImageWrapper
                            src={'/assets/images/icons/webIcons_pickIcon.svg'}
                            alt="store icon"
                        />
                    )}

                    {source ? (
                        <StyledPartnersAboutTextWrapper>
                            <StyledAboutHeading>
                                2.Select Store
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                Visit your nearest Samsung store to trade-in
                            </StyledAboutParagraph>
                        </StyledPartnersAboutTextWrapper>
                    ) : (
                        <StyledAboutTextWrapper>
                            <StyledAboutHeading>
                                {t('description.buy_back_step2')}
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                {t('description.buy_back_detail2')}
                            </StyledAboutParagraph>
                        </StyledAboutTextWrapper>
                    )}
                </AboutCard>
                <AboutCard>
                    <ImageWrapper
                        src={'/assets/images/icons/webIcons_paidIcon.svg'}
                        alt="get paid"
                    />

                    {source ? (
                        <StyledPartnersAboutTextWrapper>
                            <StyledAboutHeading>
                                3.Walk In & Get New Phone
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                Instant & secure payments as soon as device is
                                traded in.
                            </StyledAboutParagraph>
                        </StyledPartnersAboutTextWrapper>
                    ) : (
                        <StyledAboutTextWrapper>
                            <StyledAboutHeading>
                                {' '}
                                {t('description.buy_back_step3')}
                            </StyledAboutHeading>
                            <StyledAboutParagraph>
                                {t('description.buy_back_detail3')}
                            </StyledAboutParagraph>
                        </StyledAboutTextWrapper>
                    )}
                </AboutCard>
            </StyledAboutColumns>
        </StyledPartnersAboutSection>
    )
}

export default AboutSection
